import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Image, Button } from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import LatestNewsForm from "../../../components/common/latestNewsForm/index";
import Breadcrumb_arrow from "../../../assests/images/breadcrumb-arrow.svg";
import {
    LatestNewsLeft,
    LatestNewsRight,
    StateSelection,
    AllState,
    AllStateTitle,
    StateName,
    StateChange,
    StateChangeName,
    AllStateBtn,
    StateBtnTitle,
    ButtonGroupCity,
} from "./latestNewsStyle";
import { useDispatch, useSelector } from "react-redux";
import { nearestCitiesHandler } from "../../../redux/slices/location/nearest-cities";
import { LatestNewsProps } from "../../../utils/types";
import { nonprofitsHandler } from "../../../redux/slices/donationCamp/nonprofit-slice";

const LatestNews = ({ setSelectedCity, selectedCity, setSelectedCitySlug, categorySlug, selectedCitySlug, selectedFilter }: LatestNewsProps) => {
    const nearestCitiesList: any = useSelector((state: any) => state?.nearestCities?.data?.results);

    const dispatch: any = useDispatch()
    useEffect(() => {
        dispatch(nearestCitiesHandler())
    }, [])
    useEffect(() => {
        setSelectedCity(nearestCitiesList?.cities[0]?.name)
        // setSelectedCitySlug(nearestCitiesList?.cities[0]?.slug)
    }, [nearestCitiesList])

    const handleCountryClick = () => {
        const country = nearestCitiesList?.country?.name;
        dispatch(
            nonprofitsHandler({
                all: false,
                search: '',
                country: country, // Pass country here
                state: "", // Pass state if needed
                city: selectedCitySlug,
                zipcode: '',
                category: categorySlug === "all" ? "" : categorySlug as string,
                sort_by: selectedFilter as string,
                page: 1,
                size: 9,
            })
        );
    };

    const handleStateClick = () => {
        const state = nearestCitiesList?.state?.name;
        dispatch(
            nonprofitsHandler({
                all: false,
                search: '',
                country: "", // Pass country here
                state: state, // Pass state if needed
                city: selectedCitySlug,
                zipcode: '',
                category: categorySlug === "all" ? "" : categorySlug as string,
                sort_by: selectedFilter as string,
                page: 1,
                size: 9,
            })
        );
    };
    return (<>
        <LatestNewsLeft as={Col} md="12" lg="5">
            <StateSelection>
                <AllState>
                    <AllStateTitle>
                        <AllStateTitle>
                            <StateName onClick={handleCountryClick}>All {nearestCitiesList?.country?.name}</StateName>
                        </AllStateTitle>
                        {/* <StateName>All {nearestCitiesList?.country?.name}</StateName> */}
                    </AllStateTitle>
                    <StateChange>
                        <StateChangeName onClick={handleStateClick}>{nearestCitiesList?.state?.name}</StateChangeName>
                        <Image src={Breadcrumb_arrow} alt="Breadcrumb_arrow" width="16" height="16" />
                        <StateChangeName>{selectedCity}</StateChangeName>
                    </StateChange>
                </AllState>

                <AllStateBtn>
                    <StateBtnTitle>{MESSAGE.nearByCities}</StateBtnTitle>
                    <ButtonGroupCity>
                        {nearestCitiesList?.cities?.map((city: any, index: number) => (
                            <Button key={index + 1} onClick={() => { setSelectedCity(city?.name); setSelectedCitySlug(city?.slug) }} className={`${selectedCity === city?.name ? "active" : ""} city-list-btn`}>{city?.name}</Button>
                        ))}
                    </ButtonGroupCity>
                </AllStateBtn>
            </StateSelection>
        </LatestNewsLeft>

        <LatestNewsRight className="latest-news-right-side" as={Col} md="12" lg="7">
            <LatestNewsForm />
        </LatestNewsRight>
    </>);
}
export default LatestNews;
